import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from './local-storage.service';
import { Login } from '../model/request/auth';
import { UserData } from '../model/user';
import { environment } from 'src/environments/environment';
import { LoginResponse } from '../model/response/auth-r';
import { RolesResponse } from '../model/roles';


@Injectable({
  providedIn: 'root'
})
export class AuthService {


  @Output() fetchData = new EventEmitter<string>();

  
  constructor(protected http: HttpClient,
    private localStorageService: LocalStorageService) { }

  public logout(): boolean {
    this.setToken('').subscribe(() => {
    });
    return true;
  }

  // public login(param: LoginRequest): Observable<any>{
  //   return this.http.post(param)

  // }

  public getToken(): string {

    return this.localStorageService.getSession()?.token || '';
  }

  public setToken(token: string): Observable<boolean> {
    return new Observable((observer) => {
      if (token)
        this.localStorageService.setToken(token);
      else
        this.localStorageService.removeToken();

      observer.next(true);
    });
  }

  public getUserData(id:number): Observable<LoginResponse> {
    return this.http.get<LoginResponse>(`${environment.apiUrl}/user/roles/string/${id}`);
  }

  getModulesRoute(id?: number) : Observable<RolesResponse[]> {
    return this.http.get<RolesResponse[]>(`${environment.apiUrl}/roles/getmodules/${id}`);
    //return this.http.get<string[]>(`${environment.apiUrl}/modules/getall/${id}`);
  }
}
